(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3fc5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3fc5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1uKuL", function(module, exports) {

$parcel$export(module.exports, "default", () => $116ca8c6022b7c2e$export$2e2bcd8739ae039);
function $116ca8c6022b7c2e$var$debounce(callback, wait = 300, context = this) {
    let timeout = null;
    let callbackArgs = null;
    const later = ()=>callback.apply(context, callbackArgs);
    return function() {
        callbackArgs = arguments; // eslint-disable-line prefer-rest-params
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
var $116ca8c6022b7c2e$export$2e2bcd8739ae039 = $116ca8c6022b7c2e$var$debounce;

});


var $1uKuL = parcelRequire("1uKuL");
/**
 * Fork from https://github.com/ederssouza/vanillajs-scrollspy/graphs/contributors
 */ class $15e20a6ab46d25e2$var$VanillaScrollspy {
    constructor({ menu: menu, speed: speed = 2000, easing: easing = 'easeOutSine' }){
        this.$menu = menu;
        this.speed = speed;
        this.easing = easing;
        this.isJsScroll = false;
    }
    scrollToY(targetY = 0) {
        let currentTime = 0;
        const scrollTargetY = targetY;
        const scrollY = window.scrollY || document.documentElement.scrollTop;
        const self = this;
        self.isJsScroll = true;
        const time = Math.max(0.1, Math.min(Math.abs(scrollY - scrollTargetY) / this.speed, 0.8));
        const easingEquations = {
            easeOutSine (pos) {
                return Math.sin(pos * (Math.PI / 2));
            },
            easeInOutSine (pos) {
                return -0.5 * (Math.cos(Math.PI * pos) - 1);
            },
            easeInOutQuint (pos) {
                if ((pos /= 0.5) < 1) return 0.5 * pos ** 5;
                return 0.5 * ((pos - 2) ** 5 + 2);
            }
        };
        const tick = ()=>{
            currentTime += 1 / 60;
            const p = currentTime / time;
            const t = easingEquations[this.easing](p);
            if (p < 1) {
                window.requestAnimationFrame(tick);
                window.scrollTo(0, scrollY + (scrollTargetY - scrollY) * t);
                return;
            }
            window.scrollTo(0, scrollTargetY);
            self.isJsScroll = false;
        };
        tick();
    }
    menuControl() {
        const $links = this.$menu.querySelectorAll('a[href^="#"].js-nav-item');
        const scrollPos = window.scrollY || document.documentElement.scrollTop;
        const self = this;
        $links.forEach((link)=>{
            const href = link.getAttribute('href');
            const $elem = document.querySelector(href);
            const isTarget = $elem.offsetTop <= scrollPos && $elem.offsetTop + $elem.clientHeight > scrollPos;
            if (isTarget) self.targetHref = href;
            return isTarget ? link.classList.add('active') : link.classList.remove('active');
        });
    }
    animated() {
        const $links = this.$menu.querySelectorAll('a[href^="#"]');
        const self = this;
        function control(e) {
            e.preventDefault();
            const $target = document.querySelector(this.hash);
            self.scrollToY($target.offsetTop + 1);
            document.location.hash = this.hash;
        }
        $links.forEach((link)=>link.addEventListener('click', control));
    }
    init() {
        const self = this;
        self.animated();
        document.addEventListener('scroll', ()=>self.menuControl());
        document.addEventListener('scroll', (0, $1uKuL.default)(()=>{
            if (!self.isJsScroll) history.replaceState(null, null, window.location.origin + '/' + self.targetHref);
        }, 100));
    }
}
var $15e20a6ab46d25e2$export$2e2bcd8739ae039 = $15e20a6ab46d25e2$var$VanillaScrollspy;



var $1uKuL = parcelRequire("1uKuL");
function $2fd09a4e0043cf83$export$24fdf68abf432c44() {
    const position = document.documentElement.scrollTop;
    const body = document.querySelector("body");
    if (!body) return;
    body.style.top = "absolute";
    body.style.overflow = "hidden";
    body.style.position = `-${position}px`;
}
function $2fd09a4e0043cf83$export$e5d0524c3725571e() {
    const body = document.querySelector("body");
    if (!body) return;
    body.style.removeProperty("overflow");
    body.style.removeProperty("position");
    body.style.removeProperty("top");
}


class $238d3268a4b68d73$var$Nav {
    constructor(nav){
        this.nav = nav;
        this.menu = nav.querySelector('.js-nav-menu');
        this.button = nav.querySelector('.js-nav-button');
        this.items = [
            ...nav.querySelectorAll('.js-nav-item')
        ];
        this.isNavActive = false;
        this.scrollspy = new (0, $15e20a6ab46d25e2$export$2e2bcd8739ae039)({
            menu: this.menu
        });
        this.handleResize = (0, $1uKuL.default)(()=>{
            if (window.innerWidth > 767) this.removeActiveClasses();
        }, 400);
    }
    init() {
        this.scrollspy.init();
        this.navBehaviorOnScroll();
        this.items[0].classList.add('active');
        window.addEventListener('resize', this.handleResize);
        window.addEventListener('scroll', ()=>this.navBehaviorOnScroll());
        this.button.addEventListener('click', ()=>this.toggleNav());
        this.items.map((item)=>item.addEventListener('click', ()=>this.removeActiveClasses()));
    }
    toggleNav() {
        if (this.isNavActive) {
            this.nav.classList.remove('nav--active');
            (0, $2fd09a4e0043cf83$export$e5d0524c3725571e)(this.menu);
        } else {
            this.nav.classList.add('nav--active');
            (0, $2fd09a4e0043cf83$export$24fdf68abf432c44)(this.menu);
        }
        this.isNavActive = !this.isNavActive;
    }
    removeActiveClasses() {
        this.nav.classList.remove('nav--active');
        this.isNavActive = false;
        (0, $2fd09a4e0043cf83$export$e5d0524c3725571e)(this.menu);
    }
    navBehaviorOnScroll() {
        if (window.scrollY > 0) this.nav.classList.add('nav--fixed');
        else this.nav.classList.remove('nav--fixed');
    }
}
function $238d3268a4b68d73$var$navigation() {
    const navigation = document.querySelector('.js-nav');
    if (!navigation) return;
    new $238d3268a4b68d73$var$Nav(navigation).init();
}
var $238d3268a4b68d73$export$2e2bcd8739ae039 = $238d3268a4b68d73$var$navigation;



class $dc4c9df41b1f0450$var$Modal {
    constructor(modal){
        this.modal = modal;
        this.modalElements = {
            element: this.modal,
            buttons: [
                ...this.modal.querySelectorAll(`.${$dc4c9df41b1f0450$var$Modal.CLASSES.button}`)
            ],
            modal: this.modal.querySelector(`.${$dc4c9df41b1f0450$var$Modal.CLASSES.modal}`)
        };
    }
    init() {
        this.attachEvents();
    }
    attachEvents() {
        document.addEventListener('keydown', (e)=>{
            if (e.key !== "Escape" || !this.modalElements.modal.classList.contains($dc4c9df41b1f0450$var$Modal.CLASSES.active)) return;
            this.hideModal();
            (0, $2fd09a4e0043cf83$export$e5d0524c3725571e)(this.modalElements.modal);
            this.isModalOpend = false;
        });
        this.modalElements.buttons.forEach((button)=>{
            button.addEventListener('click', ()=>this.toggleModal());
        });
    }
    toggleModal() {
        if (this.isModalOpend) {
            this.hideModal();
            (0, $2fd09a4e0043cf83$export$e5d0524c3725571e)(this.modalElements.modal);
        } else {
            this.showModal();
            (0, $2fd09a4e0043cf83$export$24fdf68abf432c44)(this.modalElements.modal);
        }
        this.isModalOpend = !this.isModalOpend;
    }
    showModal() {
        this.modalElements.modal.classList.add($dc4c9df41b1f0450$var$Modal.CLASSES.active);
    }
    hideModal() {
        this.modalElements.modal.classList.remove($dc4c9df41b1f0450$var$Modal.CLASSES.active);
    }
}
$dc4c9df41b1f0450$var$Modal.CLASSES = {
    modal: 'js-modal',
    button: 'js-modal-button',
    active: 'modal--active'
};
function $dc4c9df41b1f0450$export$96e4b36520c26a2c() {
    const modals = [
        ...document.querySelectorAll('.js-modal-container')
    ];
    modals.forEach((modal)=>new $dc4c9df41b1f0450$var$Modal(modal).init());
}


function $8a16b009d12a91e0$var$clickToSelect(cls = 'js-click-to-select') {
    const elems = document.getElementsByClassName(cls);
    for (let elem of elems)elem.addEventListener("click", function() {
        window?.getSelection()?.selectAllChildren(this);
        navigator.clipboard.writeText(this.textContent);
    });
}
var $8a16b009d12a91e0$export$2e2bcd8739ae039 = $8a16b009d12a91e0$var$clickToSelect;


function $868205c313514e4e$export$a41409e30bfc5515(cls = 'cookies-eu-banner') {
    const $cookiesBanner = document.getElementsByClassName(cls).item(0);
    const $cookiesBannerButton = $cookiesBanner?.getElementsByTagName("button").item(0);
    const cookieName = "cookiesBanner";
    const hasCookie = $868205c313514e4e$var$getCookie(cookieName);
    if (!hasCookie) $cookiesBanner?.classList.remove("hidden");
    $cookiesBannerButton?.addEventListener("click", ()=>{
        $868205c313514e4e$var$setCookie(cookieName, "closed");
        $cookiesBanner?.remove();
    });
}
/**
 * @param {string} name
 */ function $868205c313514e4e$var$getCookie(name) {
    const value = " " + document.cookie;
    const parts = value.split(" " + name + "=");
    return parts.length < 2 ? undefined : parts?.pop()?.split(";").shift();
}
/**
 * @param {string} name
 * @param {string} value
 * @param {number} expiryDays
 * @param {string|undefined} domain
 * @param {string} path
 * @param {boolean} secure
 */ function $868205c313514e4e$var$setCookie(name, value, expiryDays = 365, domain, path = "/", secure = false) {
    const exdate = new Date();
    exdate.setHours(exdate.getHours() + expiryDays * 24);
    document.cookie = `${name}=${value};` + `expires=${exdate.toUTCString()};` + `path=${path || "/"}` + (domain ? `;domain=${domain};` : "") + (secure ? ";secure" : "");
}


document.addEventListener("DOMContentLoaded", ()=>{
    (0, $238d3268a4b68d73$export$2e2bcd8739ae039)();
    (0, $dc4c9df41b1f0450$export$96e4b36520c26a2c)();
    (0, $8a16b009d12a91e0$export$2e2bcd8739ae039)('js-click-to-select');
    (0, $868205c313514e4e$export$a41409e30bfc5515)('cookies-eu-banner');
});

})();
//# sourceMappingURL=main.js.map
